module.exports = __webpack_public_path__ + "static/media/bbuzz.3e47418f.svg";